import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from "./router"
import vuetify from './plugins/vuetify';
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import vueScrollto from 'vue-scrollto'
import VueResizeText from 'vue-resize-text';

Vue.config.productionTip = false

Vue.use(VueResizeText)
Vue.use(VueRouter)
Vue.use(VueVideoPlayer)
Vue.use(vueScrollto, {
  offset: -105
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')